import { servicesAccessOptions } from "./connection-utils";
import fetch from "cross-fetch";

function buildApiCall(endpoint, method, requestData) {
  let serviceLocation = endpoint;
  if (!serviceLocation.startsWith('/')) {
    serviceLocation = '/' + endpoint;
  }

  const requestDescriptor = {
    mode: 'cors',
    credentials: 'include',
    method: method,
  };

  if (requestDescriptor.headers === undefined) {
    requestDescriptor.headers = {};
  }

  if (servicesAccessOptions.accessToken !== undefined) {
    requestDescriptor.headers['x-access-token'] = servicesAccessOptions.accessToken;
  }

  if (method === 'POST') {
    requestDescriptor.headers['Content-Type'] = 'application/json';
    requestDescriptor.body = JSON.stringify(requestData);
  }

  return fetch(`${process.env.REACT_APP_API_URL}` + serviceLocation, requestDescriptor)
}

// Fetches an API response and normalizes the result JSON according to schema.
// This makes every API response have the same shape, regardless of how nested it was.
function callApi(endpoint, method, requestData) {
  return buildApiCall(endpoint, method, requestData)
    .then((r) => {
      // Check if authorization is required
      if (r.status === 401 || r.status === 403) {
        // Redirect to account-login page
        let error = new Error('AUTH_REQUIRED');
        error.errorType = 'AUTH_REQUIRED';
        error.status = r.status;
        throw error;
      }

      // Check if server failed to process the request
      if (r.status === 500) {
        let error = new Error('SVC_ERROR');
        error.errorType = 'SVC_ERROR';
        error.status = r.status;
        throw error;
      }

      return r;
    })
    .then((r) =>
      // If there are any data in the HTTP response, place them in the return
      // object. Otherwise, leave body field in return object undefined.
      r.json()
        .then(data => ({response: r, body: data}))
        // It is expected that an error exists when data are not present and
        // code cannot parse response into a JSON.
        .catch((error) => ({response: r, body: undefined}))
    )
    .then(({ response, body }) => {
      if (!response.ok) {
        return Promise.reject(body)
      }

      return Object.assign({}, body);
    })
    .then(
      response => ({response}),
      error => ({error: error.message || 'Something bad happened'})
    )
}

const HTTP_GET = "GET";
const HTTP_POST = "POST";

export const fetchUserProfile = () => callApi('/v1/profile', HTTP_GET)
export const logoutUserProfile = () => callApi('/v1/authentication/logout', HTTP_GET)

export const fetchVolunteerApplication = (applicationId) => buildApiCall('/v1/volunteer/application/' + applicationId, HTTP_GET)
export const postVolunteerApplicationDecision = (data) => buildApiCall('/v1/volunteer/application', HTTP_POST, data)

// Settings services
export const fetchLinesOfEducation = () => buildApiCall('/v1/settings/linesOfEducation', HTTP_GET)

